export const STATUS_LIST_VARIANTS = [
    { id: 'dot-list', label: 'Dot List', icon: 'fas fa-circle' },
    { id: 'badge-list', label: 'Badge List', icon: 'fas fa-tag' },
    { id: 'icon-list', label: 'Status Icons', icon: 'fas fa-check-circle' },
    { id: 'card-grid', label: 'Card Grid', icon: 'fas fa-th-large' },
    { id: 'avatar-list', label: 'Avatar List', icon: 'fas fa-user-circle' },
    { id: 'progress-rows', label: 'Health Bars', icon: 'fas fa-signal' },
    { id: 'timeline', label: 'Timeline', icon: 'fas fa-stream' },
    { id: 'table-style', label: 'Table Style', icon: 'fas fa-table' },
    { id: 'compact-chips', label: 'Compact Chips', icon: 'fas fa-tags' },
    { id: 'minimal-text', label: 'Minimal Text', icon: 'fas fa-align-left' },
];
